/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getSyncEntityMetadata} from '../api'

 export const useQueryGetSyncEntityMetadata = createReactQueryHook('getSyncEntityMetadata', getSyncEntityMetadata)
